import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getOrderListRequest, getOrderListRequestError, getOrderListRequestSuccess } from "../../slices/Order/GetOrderList";

export const OrdersListApi = (userType, page, limit, search = '', status = '', type = 1) => async (dispatch) => {

    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        userType: userType,
        search: search,
        status: status,
        type: type
    }).toString();

    const urlWithParams = `${endpoints.getOrdersList}?${queryParams}`;
    try {
        dispatch(getOrderListRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getOrderListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getOrderListRequestError(_error));
            });
    } catch (error) { }
};
